<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 ml-0 md:ml-4 aarni-font">Scholarship</h1>
    </div>
</div>
<div class="p-6 max-w-7xl mx-auto">
    <div class="bg-blue-50 p-6 rounded-lg shadow">
        <h2 class="text-xl font-bold mb-4 uppercase">Scholarship Eligibility Form <span class="text-sm font-normal">(For International Students Only)</span></h2>
        <form (ngSubmit)="onSubmit()" [formGroup]="scholarshipForm">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="">
                    <label class="block text-sm font-medium mb-1">Full Name</label>
                    <input type="text" formControlName="fullName" placeholder="Enter Your Name" class="w-full outline-none border rounded py-2 px-3">
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Email ID</label>
                    <input type="email" formControlName="email" placeholder="Enter Your Email ID" class="w-full border outline-none rounded py-2 px-3">
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Country</label>
                    <select formControlName="country" class="w-full border rounded bg-white py-2 px-3 outline-none">
                        <option>Select Country</option>
                        <!-- Add options -->
                    </select>
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">City/Town</label>
                    <input type="text" formControlName="city" placeholder="Enter Your City" class="w-full outline-none border rounded py-2 px-3">
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Mobile No.</label>
                    <div class="flex">
                        <span class="inline-flex items-center px-3  bg-white  border border-r-0 rounded-l">+91</span>
                        <input type="text" formControlName="mobile" placeholder="Enter your mobile number" class="w-full outline-none border rounded py-2 px-3 rounded-l-none">
                    </div>
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Programme Type</label>
                    <select formControlName="programmeType" class="w-full border bg-white rounded py-2 outline-none">
                        <option>Select Programme</option>
                    </select>
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Programme Discipline</label>
                    <select formControlName="programmeDiscipline" class="w-full border bg-white rounded py-2 outline-none">
                        <option>Select Discipline</option>
                    </select>
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Course</label>
                    <select formControlName="course" class="w-full bg-white border rounded py-2 outline-none">
                        <option>Select Course</option>
                    </select>
                </div>
            </div>

            <div class="mt-6">
                <label class="block text-sm font-semibold mb-2">Upload Mark Sheets <span class="text-xs text-gray-500">(PDF, JPG, JPEG, PNG)</span></label>

                <div class="space-y-4">
                    <div class="flex items-center space-x-4">
                        <span class="w-40 text-sm font-medium">10th / 'O' Level</span>
                        <input type="file" class=" text-sm text-gray-700 rounded px-2 py-1 file:mr-4 file:py-1 file:px-4 file:border-0 file:text-sm file:font-semibold file:bg-green-500 file:text-white hover:file:bg-green-600" />
                    </div>
                    <div class="flex items-center space-x-4">
                        <span class="w-40 text-sm font-medium">12th / 'A' Level</span>
                        <input type="file" class=" text-sm text-gray-700 rounded px-2 py-1 file:mr-4 file:py-1 file:px-4 file:border-0 file:text-sm file:font-semibold file:bg-green-500 file:text-white hover:file:bg-green-600">
                    </div>
                    <div class="flex items-center space-x-4">
                        <span class="w-40 text-sm font-medium">Graduate</span>
                        <input type="file" class=" text-sm text-gray-700 rounded px-2 py-1 file:mr-4 file:py-1 file:px-4 file:border-0 file:text-sm file:font-semibold file:bg-green-500 file:text-white hover:file:bg-green-600">
                    </div>
                    <div class="flex items-center space-x-4">
                        <span class="w-40 text-sm font-medium">Post Graduate</span>
                        <input type="file" class=" text-sm text-gray-700 rounded px-2 py-1 file:mr-4 file:py-1 file:px-4 file:border-0 file:text-sm file:font-semibold file:bg-green-500 file:text-white hover:file:bg-green-600">
                    </div>
                </div>
            </div>

            <div class="mt-6 text-center">
                <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-2 rounded">Submit</button>
            </div>
        </form>
    </div>
</div>
